import { DialogProps } from '@mui/material/Dialog/Dialog';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { FunctionField } from 'shared/react-admin/Fields';
import { RelatedCommissionsLink } from 'shared/react-admin/Links/RelatedCommissionsLink/RelatedCommissionsLink';
import { CommissionsShowChipFields } from 'shared/widgets/CommissionsShowChipFields/CommissionsShowChipFields';
import { CommissionsTabs } from 'shared/widgets/CommissionsTabs/CommissionsTabs';
import { Commission } from 'types/embedded/commission';

type Props = {
  commission: Commission;
  onClose: () => void;
} & DialogProps;

export const CommissionShowDialog: React.FC<Props> = ({ open, commission, onClose }) => {
  const translate = useTypedTranslate();

  return (
    <Dialog fullWidth maxWidth="lg" onClose={onClose} open={open}>
      <RecordContextProvider value={commission}>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title={translate('app.commissions.details')}
          titleSize="smallBold"
        />
        <Box p={3}>
          <CommissionsShowChipFields />
          <CommissionsTabs
            relatedField={
              <FunctionField
                render={(record: Commission) => <RelatedCommissionsLink record={record} />}
              />
            }
          />
        </Box>
      </RecordContextProvider>
    </Dialog>
  );
};
